import { toast } from 'react-toastify';
import i18n from 'src/i18n/i18n';

// Messages globaux pour les pannes qui ne dépendent pas de l'écran en cours :
// internet coupé, serveur injoignable, en maintenance (502/503/504) ou en erreur (500).
// Chaque type de message a un toastId fixe : si dix requêtes échouent en même
// temps, un seul toast s'affiche au lieu de dix.

const TOAST_IDS = {
  offline: 'net-offline',
  network: 'net-error',
  unavailable: 'server-unavailable',
  server: 'server-error'
};

function showError(id, key) {
  if (toast.isActive(id)) return;
  toast.error(i18n.t(key), { toastId: id });
}

// Renvoie le type d'erreur (network / unavailable / server) ou null si ce n'est
// pas une panne réseau/serveur (400, 401, 404… restent gérés par chaque écran).
export function getServerErrorKind(error) {
  if (!error || (error.code === 'ERR_CANCELED' || error.__CANCEL__)) return null;
  if (!error.response) return 'network';
  var status = error.response.status;
  if (status === 502 || status === 503 || status === 504) return 'unavailable';
  if (status >= 500) return 'server';
  return null;
}

export function getServerErrorMessageKey(kind) {
  if (kind === 'network') {
    return navigator.onLine === false ? 'serverErrors.offline' : 'serverErrors.network';
  }
  if (kind === 'unavailable') return 'serverErrors.unavailable';
  if (kind === 'server') return 'serverErrors.server';
  return null;
}

export function notifyServerError(error) {
  var kind = getServerErrorKind(error);
  if (!kind) return;
  if (kind === 'network' && navigator.onLine === false) {
    showError(TOAST_IDS.offline, 'serverErrors.offline');
    return;
  }
  showError(TOAST_IDS[kind], getServerErrorMessageKey(kind));
}

// Coupure / retour d'internet signalés par le navigateur : le toast « hors ligne »
// reste affiché tant que la connexion n'est pas revenue.
export function listenToConnectivity() {
  window.addEventListener('offline', function() {
    if (toast.isActive(TOAST_IDS.offline)) return;
    toast.error(i18n.t('serverErrors.offline'), {
      toastId: TOAST_IDS.offline,
      autoClose: false,
      closeOnClick: false
    });
  });
  window.addEventListener('online', function() {
    toast.dismiss(TOAST_IDS.offline);
    toast.dismiss(TOAST_IDS.network);
    toast.success(i18n.t('serverErrors.backOnline'), { toastId: 'net-online' });
  });
}
